import { render, staticRenderFns } from "./EventDateSettings.vue?vue&type=template&id=b506cf86&scoped=true&"
import script from "./EventDateSettings.vue?vue&type=script&lang=js&"
export * from "./EventDateSettings.vue?vue&type=script&lang=js&"
import style0 from "./EventDateSettings.vue?vue&type=style&index=0&id=b506cf86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b506cf86",
  null
  
)

export default component.exports